import { ROLES, normalizeUserLocality, getWorkShowIanaTimezone } from '../../utils/constant/global';
import { getIanaTimezoneForLocality } from '../../utils/timedoctorAttendanceHelpers';

const getLoggedInUserFromState = (state) => {
  const queries = state?.userAuth?.queries;
  if (!queries) return null;

  const entry = Object.entries(queries).find(([key]) => key.includes('isLoggedIn'));
  return entry?.[1]?.data?.data ?? null;
};

const usesSelectedOffice = (roleName) => roleName === ROLES.ADMIN || roleName === ROLES.ACCOUNTANT;

/** Locality query params for API calls (IN / AU). */
export const selectApiLocality = (state) => {
  const officeLocality = state?.office?.locality || state?.office?.nationality || [];
  const user = getLoggedInUserFromState(state);
  const roleName = user?.hrxRole?.roleName;

  if (usesSelectedOffice(roleName) && officeLocality.length) {
    return officeLocality;
  }

  const userLocality = normalizeUserLocality(user?.locality ?? user?.nationality);
  if (userLocality.length) {
    return userLocality;
  }

  return officeLocality;
};

/**
 * Clocks / ranges display timezone:
 * - Admin and Accountant → selected sidebar office TZ
 * - Everyone else → profile locality TZ (AU → Sydney, IN → Kolkata)
 */
export const selectDisplayTimezone = (state) => {
  const user = getLoggedInUserFromState(state);
  const roleName = user?.hrxRole?.roleName;
  const officeTimezone =
    state.office?.timezone || getWorkShowIanaTimezone(state.office?.selectedOfficeId);

  if (usesSelectedOffice(roleName)) {
    return officeTimezone || 'Asia/Kolkata';
  }

  const userLocality = normalizeUserLocality(user?.locality ?? user?.nationality);
  if (userLocality.length) {
    return getIanaTimezoneForLocality(userLocality);
  }

  return officeTimezone || 'Asia/Kolkata';
};
